import {
  IOrder,
  IPayResponse,
  IChekTransactionResponse
} from './../model/types'

export const transformOrder = (data: any): IOrder => {
  if (data.result) {
    const order = data.result
    return {
      active: data.active,
      acc_number: order.acc_number ?? null,
      acquiringCode: order.acquiringCode ?? null,
      bonus: order.bonus,
      currencyTypeSelected: order.currencyTypeSelected,
      discount: order.discount ?? 0,
      discountStatus: order.discountStatus,
      fee_type: order.fee_type,
      global_system_loyalty: order.global_system_loyalty ?? {},
      guest: order.guest ?? null,
      loyalty_system: order.loyalty_system,
      name: order.name,
      orders: order.orders ?? [],
      ordersElementAll: order.ordersElementAll ?? [],
      prepayment: order.prepayment ?? null,
      public_id: order.public_id,
      recipient: order.recipient,
      review_display_type: order.review_display_type ?? null,
      responseTemplate: order.responseTemplate,
      settings: order.settings ?? null,
      tableCode: order.tableCode,
      tipsType: order.tips_type,
      tips: order.tips,
      waiter: order.waiter ?? null,
      hookah: order.hookah ?? null,
      kitchener: order.kitchener ?? null,
      session: order.orders && order.orders.length ? order.orders[0].sessions_id : null,
      restId: order.restId,
      team: order.team
    }
  }
  return data
}

export const transformPayResponse = (data: any): IPayResponse => {
  if (data?.success === false || data?.active === false || !data?.result) {
    throw new Error(data?.error || 'Не удалось создать платёж')
  }

  return {
    link: data.result,
    pay_web_url: data.pay_web_url || null,
    transaction_id: data.transaction_id
  }
}

export const transformCheckTransaction = (data: any): IChekTransactionResponse => {
  const transaction = data.data
  return {
    success: data.success,
    status: transaction.status,
    message: transaction.message,
    statuses: transaction.statuses,
    original_statuses: transaction.original_statuses,
    transaction_paid_position_ids: transaction.transaction_paid_position_ids,
    transaction_payment: transaction.transaction_payment,
    shop: transaction.shop,
    waiter: transaction.waiter,
    session_ids: transaction.session_ids,
    session_amount: transaction.session_amount
  }
}
